import { render, staticRenderFns } from "./frp.vue?vue&type=template&id=a61fa2e0&scoped=true"
import script from "./frp.vue?vue&type=script&lang=js"
export * from "./frp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61fa2e0",
  null
  
)

export default component.exports